import { createFileRoute } from '@tanstack/react-router';
import WarRoom from 'src/pages/Organization/Event/WarRoom';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/war_room',
)({
  component: WarRoom,
});
